<script setup>
defineProps({
  items: {
    type: Array,
    default: () => [],
  },
});
const emit = defineEmits(['redirect']);

const { t } = useI18n();

function handleLinkClick(link, callback = undefined) {
  if (callback) callback();
  emit('redirect', link);
}
</script>

<template>
  <div class="lists-menu-links">
    <CTagDetect
      v-for="(item, index) in items"
      :key="index"
      :to="item.link"
      class="lists-menu-links__link"
      active-class="lists-menu-links__link--active"
      @click="() => handleLinkClick(item.link, item.onClick)"
    >
      <span class="lists-menu-links__font">
        {{ t(item.text) }}
        <span v-if="item.count" class="lists-menu-links__count">
          {{ item.count }}
        </span>
      </span>
    </CTagDetect>
  </div>
</template>

<style scoped lang="scss">
.lists-menu-links {
  display: flex;
  flex-direction: column;
  gap: em(25);
  align-items: center;

  &__font {
    font-size: em(17);
    line-height: math.div(19, 17);
  }

  &__link {
    color: $color-white;

    &--active {
      color: $color-second-1;
    }
  }

  &__count {
    color: $color-second-1;
  }
}
</style>
